import { access, headerWithoutBanner, leftHandSection, rightHandSection } from './utils';

export const scopeOfFeatures: Record<string, Record<string, string[]>> = {
  'GPS Investments': {
    [access.ADMIN]: [],
    [access.EDIT]: [],
    [access.VIEW]: [
      ...Object.values(headerWithoutBanner),
      ...Object.values(leftHandSection),
      ...Object.values(rightHandSection),
    ],
  },
  CoSell: {
    [access.ADMIN]: [],
    [access.EDIT]: [],
    [access.VIEW]: [],
  },
  RoB: {
    [access.ADMIN]: [],
    [access.EDIT]: [],
    [access.VIEW]: [],
  },
};
